var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31641 7.17383C8.51172 7.34961 8.73633 7.4375 8.99023 7.4375C9.24414 7.4375 9.45898 7.34961 9.63477 7.17383C9.83008 6.99805 9.92773 6.77344 9.92773 6.5C9.92773 6.22656 9.83008 6.00195 9.63477 5.82617C9.45898 5.65039 9.24414 5.5625 8.99023 5.5625C8.73633 5.5625 8.51172 5.65039 8.31641 5.82617C8.14062 6.00195 8.05273 6.22656 8.05273 6.5C8.05273 6.77344 8.14062 6.99805 8.31641 7.17383ZM6.5 8.99023V4.00977H12.7402V8.99023H6.5ZM12.125 10.25V10.8652C12.125 11.1973 11.998 11.4902 11.7441 11.7441C11.4902 11.998 11.1973 12.125 10.8652 12.125H2.13477C1.7832 12.125 1.48047 12.0078 1.22656 11.7734C0.992188 11.5195 0.875 11.2168 0.875 10.8652V2.13477C0.875 1.7832 0.992188 1.49023 1.22656 1.25586C1.48047 1.00195 1.7832 0.875 2.13477 0.875H10.8652C11.1973 0.875 11.4902 1.00195 11.7441 1.25586C11.998 1.50977 12.125 1.80273 12.125 2.13477V2.75H6.5C6.14844 2.75 5.8457 2.87695 5.5918 3.13086C5.35742 3.36523 5.24023 3.6582 5.24023 4.00977V8.99023C5.24023 9.3418 5.35742 9.64453 5.5918 9.89844C5.8457 10.1328 6.14844 10.25 6.5 10.25H12.125Z",
    fill: "url(#paint0_linear_340_348)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_348",
    x1: -1,
    y1: 6.5,
    x2: 14,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529DD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWallet);
export default __webpack_public_path__ + "static/media/ic_wallet.8646865666f5d8eab1a4f3d978d1516d.svg";
export { ForwardRef as ReactComponent };